import { AppModal, AppModalBody, AppModalFooter } from "./AppModal";

export function ViewDetailModal({ open, onClose, title, subtitle, meta, children, size = "md" }) {
  if (!open) return null;

  return (
    <AppModal open={open} onClose={onClose} title={title} subtitle={subtitle} size={size}>
      <AppModalBody>
        {meta ? <DetailHero>{meta}</DetailHero> : null}
        {children}
      </AppModalBody>
      <AppModalFooter>
        <button
          type="button"
          className="btn btn-ghost btn-sm h-9 min-h-9 rounded-lg px-4 text-sm"
          onClick={onClose}
        >
          Close
        </button>
      </AppModalFooter>
    </AppModal>
  );
}

export function DetailHero({ children }) {
  return <div className="ui-view-hero">{children}</div>;
}

export function DetailGrid({ children }) {
  return <dl className="ui-view-detail-grid">{children}</dl>;
}

export function DetailItem({ label, value, span = 1, children }) {
  const spanClass = span === 2 ? "sm:col-span-2" : "";
  return (
    <div className={`ui-view-detail-row ${spanClass}`.trim()}>
      <dt className="ui-view-detail-label">{label}</dt>
      <dd className="ui-view-detail-value">{children ?? value ?? "-"}</dd>
    </div>
  );
}

export function DetailSection({ title, children }) {
  return (
    <section className="ui-view-detail-section">
      {title ? (
        <div className="ui-view-detail-section-head">
          <h4 className="ui-view-detail-section-title">{title}</h4>
        </div>
      ) : null}
      <div className="ui-view-detail-section-body">{children}</div>
    </section>
  );
}

export function DetailTags({ items, variant = "primary" }) {
  if (!items?.length) return <span className="text-sm text-base-content/50">-</span>;

  const badgeClass =
    variant === "outline"
      ? "badge badge-outline badge-sm border-base-300 bg-base-100"
      : "badge badge-primary badge-sm border-primary/20 bg-primary/10 text-primary";

  return (
    <div className="mt-1 flex max-h-24 flex-wrap gap-1.5 overflow-auto pr-0.5">
      {items.map((item) => (
        <span key={item} className={badgeClass}>
          {item}
        </span>
      ))}
    </div>
  );
}
